import { memo } from 'react';

import useLocalStorageState from 'core/hooks/browser/useLocalStorageState';
import { MenuItem } from 'core/ui/Menu';
import ICONS from 'core/ui/icons';

import { NSFW_DISABLED_LS_KEY } from './storage';

export default memo(function NSFWMenuItem() {
  const [isDisabled, setIsDisabled] = useLocalStorageState(
    NSFW_DISABLED_LS_KEY,
    false
  );

  return (
    <MenuItem
      label={isDisabled ? 'Enable showing NSFW' : 'Disable showing NSFW'}
      icon={ICONS.Eye}
      onClick={() => setIsDisabled(v => !v)}
    />
  );
});
